"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setToken = exports.getToken = exports.getRefreshToken = exports.credentialsSharing = exports.credentialsRequest = exports.credentialsFlush = void 0;
exports.useToken = useToken;
var _react = require("react");
var _LocalStorage = require("../../constants/LocalStorage");
var _TabsEnum = require("../../constants/TabsEnum");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Utility function to safely parse stored JSON
const safeParse = item => {
  try {
    return JSON.parse(item);
  } catch (_unused) {
    return null;
  }
};

// Get token from sessionStorage
const getStoredToken = key => {
  const tokenString = sessionStorage.getItem(key);
  return tokenString && tokenString !== "undefined" ? safeParse(tokenString) : '';
};

// Hook to get and set the token
function useToken() {
  const [token, setTokenState] = (0, _react.useState)(getStoredToken(_LocalStorage.LocalStorageVariables.PageToken));
  const saveToken = userToken => {
    if (userToken !== null && userToken !== void 0 && userToken.refresh_token) {
      const refreshToken = {
        refreshToken: userToken.refresh_token,
        tokenUses: 0
      };
      sessionStorage.setItem("refresh", JSON.stringify(refreshToken));
      delete userToken.refresh_token; // Remove refresh token from the main token object
    }
    sessionStorage.setItem(_LocalStorage.LocalStorageVariables.PageToken, JSON.stringify(userToken));
    setTokenState(userToken); // Update the state
  };
  return {
    setToken: saveToken,
    token
  };
}

// Retrieve access token from storage
const getToken = () => getStoredToken(_LocalStorage.LocalStorageVariables.PageToken);

// Retrieve refresh token from storage
exports.getToken = getToken;
const getRefreshToken = () => getStoredToken("refresh");

// Store token and refresh token in storage
exports.getRefreshToken = getRefreshToken;
const setToken = userToken => {
  if (userToken !== null && userToken !== void 0 && userToken.refresh_token) {
    const refreshToken = {
      refreshToken: userToken.refresh_token,
      tokenUses: 0
    };
    sessionStorage.setItem("refresh", JSON.stringify(refreshToken));
    delete userToken.refresh_token;
  }
  sessionStorage.setItem(_LocalStorage.LocalStorageVariables.PageToken, JSON.stringify(userToken));
};

// Trigger logoff in all tabs by removing the token
exports.setToken = setToken;
const credentialsFlush = () => {
  localStorage.setItem(_TabsEnum.TabsEnum.removeToken, Date.now().toString());
  localStorage.removeItem(_TabsEnum.TabsEnum.removeToken);
};

// Share token across tabs
exports.credentialsFlush = credentialsFlush;
const credentialsSharing = () => {
  const token = getToken();
  const refresh = getStoredToken("refresh");
  if (token && refresh) {
    const userToken = _objectSpread(_objectSpread({}, token), {}, {
      refresh_token: refresh.refreshToken
    });
    localStorage.setItem(_TabsEnum.TabsEnum.sharingCredentials, JSON.stringify(userToken));
    localStorage.removeItem(_TabsEnum.TabsEnum.sharingCredentials);
  }
};

// Request token from other tabs
exports.credentialsSharing = credentialsSharing;
const credentialsRequest = () => {
  localStorage.setItem(_TabsEnum.TabsEnum.startingTab, Date.now().toString());
  localStorage.removeItem(_TabsEnum.TabsEnum.startingTab);
};
exports.credentialsRequest = credentialsRequest;